const validateTrackingNumber = (type) => {
  switch (type) {
    case "mawb":
      return {
        validationPattern: /^[0-9]{3}-[0-9]{8,10}$/i,
        infoMessage: (
          <div className="mt-3">
            <p className="mb-0">The first 3 digits are the Airline Prefix, followed by a dash, and 8 digits </p>
            <p className="mt-1">MAWB tracking number could look something like: 123-45678901</p>
          </div>
        ),
        placeholder: "i.e. 123-12345678",
      };
    case "mbol":
      return {
        validationPattern: /^[0-9]{7,10}$/i,
        infoMessage: (
          <p className="mt-3">
            The first 4 characters are the{" "}
            <a href="https://en.wikipedia.org/wiki/Standard_Carrier_Alpha_Code" target="_blank" rel="noopener noreferrer">
              SCAC
            </a>{" "}
            code followed by 7-10 characters
          </p>
        ),
        placeholder: "i.e. 123456789",
      };

    case "container_no":
      return {
        validationPattern: /^[A-Za-z]{4}\d{7}$/i,
        infoMessage: <p className="mt-2">first 4 capital letters followed by 7 numbers</p>,
        placeholder: "i.e. ACBD1735654",
      };
    case "rail_car":
      return {
        validationPattern: /^[A-Za-z]{4}\d{7}$/i,
        infoMessage: <p className="mt-2">4 letters followed by 7 digits</p>,
      };
    default:
      return {
        validationPattern: null,
        infoMessage: "",
        placeholder: "Please provide",
      };
  }
};

/*
Previous code which we might need to use for validation on the tracking page
return {
  validationPattern: /^[A-Za-z]{4}[0-9]{8,10}$/i,
  infoMessage: (
    <p>
      The first 4 characters are the{" "}
      <a href="https://en.wikipedia.org/wiki/Standard_Carrier_Alpha_Code" target="_blank" rel="noreferrer">
        SCAC code
      </a>
      , followed by 8 - 10 characters
    </p>
  ),
  placeholder: "i.e. XXXX123456789",
};
*/

export default validateTrackingNumber;
